/* Zestpics upsell & cross-sell (Claude redesign, Sep 2026)
   - Product page: "Complete the gift" add-ons + a sheet after Add to cart with add-ons and a View cart button.
   - Cart page: "Add a little extra" add-ons based on what is in the cart.
   Products are picked in Liquid by snippets/zp-pairs (same category + complementary collections, price-aware).
   Falls back to Shopify's product recommendations only if the box arrives empty. One-tap add. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = function (cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function recs(pid, intent, limit) {
    return fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=' + limit + '&intent=' + intent, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return j.products || []; })
      .catch(function () { return []; });
  }

  function addons(pid, exclude, limit) {
    var seen = {};
    (exclude || []).forEach(function (id) { seen[String(id)] = 1; });
    return recs(pid, 'complementary', 10).then(function (list) {
      if (list.length >= limit) return list;
      return recs(pid, 'related', 10).then(function (rel) { return list.concat(rel); });
    }).then(function (list) {
      return list.filter(function (p) {
        if (seen[String(p.id)]) return false;
        seen[String(p.id)] = 1;
        return p.available && p.variants && p.variants.some(function (v) { return v.available; });
      }).slice(0, limit);
    });
  }

  function cartJs() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return cartJs();
    }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'zp-upsell', data: { source: 'zp-upsell', itemCount: cart.item_count } } }));
      return cart;
    });
  }

  function img(p) {
    var src = p.featured_image || (p.images && p.images[0]) || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }

  function card(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0];
    var cmp = v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '';
    return '<li class="zpu__item">' +
      '<a class="zpu__img" href="' + esc(p.url) + '"><img src="' + esc(img(p)) + '" alt="' + esc(p.title) + '" width="120" height="120" loading="lazy"></a>' +
      '<div class="zpu__info"><a class="zpu__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="zpu__price"><b>' + money(v.price) + '</b>' + cmp + '</span></div>' +
      '<button type="button" class="zpu__add" data-zpu-add="' + v.id + '" aria-label="Add ' + esc(p.title) + ' to cart">+ Add</button>' +
      '</li>';
  }

  function wire(scope, afterAdd) {
    scope.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zpu-add]');
      if (!b || b.disabled) return;
      b.disabled = true; b.textContent = 'Adding…';
      addToCart(b.getAttribute('data-zpu-add')).then(function (cart) {
        b.textContent = '✓ Added'; b.classList.add('is-added');
        if (afterAdd) afterAdd(cart);
      }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
    });
  }

  /* Volume offer progress (matches automatic discounts: 2 = 10%, 3+ = 15%, 10+ = 20%) */
  function tier(el, n) {
    if (!el) return;
    var t = n >= 10 ? 'You’re saving 20% ✓' : n >= 3 ? 'You’re saving 15% ✓ on your order' : n === 2 ? 'You’re saving 10% ✓ — add 1 more to save 15%' : 'Add 1 more item and save 10% on your whole order';
    el.textContent = t; el.hidden = false; el.classList.toggle('is-on', n >= 2);
  }

  /* ---------- Product page ---------- */
  function prefilled(box) {
    var items = box.querySelectorAll('.zpu__list > .zpu__item');
    return items.length ? Promise.resolve({ html: Array.prototype.map.call(items, function (li) { return li.outerHTML; }), ready: true }) : null;
  }

  var pdp = document.querySelector('[data-zp-upsell="pdp"]');
  if (pdp) {
    var pid = pdp.getAttribute('data-product-id');
    (prefilled(pdp) || addons(pid, [pid], 3).then(function (list) { return { html: list.map(card), ready: false }; })).then(function (res) {
      var list = res.html;
      if (!list.length) return;
      if (!res.ready) pdp.querySelector('.zpu__list').innerHTML = list.join('');
      pdp.hidden = false;
      wire(pdp);

      /* Sheet shown right after the main Add to cart */
      var sheet = document.createElement('div');
      sheet.className = 'zpu-sheet'; sheet.hidden = true;
      sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-label', 'Added to cart');
      sheet.innerHTML = '<div class="zpu-sheet__panel"><button type="button" class="zpu-sheet__x" aria-label="Close">×</button>' +
        '<p class="zpu-sheet__ok">✓ Added to your cart</p>' +
        '<p class="zpu-sheet__tier" data-zpu-tier hidden></p>' +
        '<p class="zpu-sheet__h">Make it extra special — add one more</p>' +
        '<ul class="zpu__list">' + list.slice(0, 2).join('') + '</ul>' +
        '<div class="zpu-sheet__cta"><a class="zpu-sheet__cart" href="' + root + 'cart">View cart &amp; checkout</a>' +
        '<button type="button" class="zpu-sheet__keep">Keep shopping</button></div></div>';
      document.body.appendChild(sheet);
      wire(sheet);
      var close = function () { sheet.hidden = true; };
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('.zpu-sheet__x') || e.target.closest('.zpu-sheet__keep')) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      /* Add to cart now goes straight to the cart page (see zp-brand-polish), so the sheet stays closed. */
    });
  }

  /* ---------- Cart page ---------- */
  var cartBox = document.querySelector('[data-zp-upsell="cart"]');
  if (cartBox) {
    var ids = (cartBox.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var first = cartBox.getAttribute('data-product-id');
    if (first) {
      (prefilled(cartBox) || addons(first, ids, 4).then(function (list) { return { html: list.map(card), ready: false }; })).then(function (res) {
        var list = res.html;
        if (!list.length) return;
        if (!res.ready) cartBox.querySelector('.zpu__list').innerHTML = list.join('');
        cartBox.hidden = false;
        wire(cartBox, function () { setTimeout(function () { window.location.reload(); }, 400); });
      });
    }
  }
})();
